import {useState, useEffect,Fragment} from 'react';
import { Box, TextField, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import ContactosService from '../../services/contactos.service';
import CardSearchNav from '../card/CardSearchNav';

const InputSearchDireccionEntrega = ({value,disabled,onChange,isClearable,errorText,onClick,borderChange, ...props}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const [textSearch, setTextSearch] = useState('');
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleSearchContacto = async(query) => {
        setIsLoading(true);
        await ContactosService.getAll({search: query,typeSearch: 'dirEnt'}).then((data)=>{
            setOptions( data.map((item) =>{
                if(!item?.id_t){
                    return {
                        ...item,
                        tituloCard: `${item?.contrato} - ${item?.nombre}`,
                        descripCard: `${item?.direccion_servicio || 'S/D'} - ${item?.cod_segmento || ''}`,
                        empresaCard: 'NUBICOM',
                        keyCard: `${item?.contrato}Cuenta`
                    }
                }
                return {
                    ...item,
                    tituloCard: `${item?.id_t} - ${item?.nombre_t}`,
                    descripCard: `${item?.direccion_t || 'S/D'} - ${item?.categoria_t || ''}`,
                    empresaCard: 'NUBICOM',
                    keyCard: `${item?.id_t}Contacto`
                }
            }))
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    useEffect(() => {
        if(textSearch?.length > 2){
            const delayWrite = setTimeout(() => {
                handleSearchContacto(textSearch)
            }, 600)
            return () => clearTimeout(delayWrite)
        }
    }, [textSearch])

    return (
        <Box sx={{display: 'flex'}}>
            <Autocomplete
                id="asynchronous-demo"
                freeSolo
                isOptionEqualToValue={(option, value) => option?.tituloCard === value?.tituloCard}
                getOptionLabel={(option) => `${option?.tituloCard} ${option?.descripCard}`}
                options={options}
                filterOptions={(options) => options}
                loading={isLoading}
                disableClearable
                fullWidth
                sx={{
                    marginTop: 0.5,
                    marginLeft: -0.2,
                    '& fieldset': {
                        borderRadius: borderChange ? 2 : 7,
                        borderColor: isDarkMode ? '#3d4a62' : '#e0e0e0',
                        borderWidth: 2,
                        height: 43.5,
                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                    },
                    '& .Mui-disabled .MuiOutlinedInput-notchedOutline':{
                        borderRadius: borderChange ? 2 : 7,
                        borderColor: isDarkMode ? '#3d4a62 !important' : '#808080 !important',
                        border: 1,
                        color: isDarkMode ? '#b0bec5 !important' : '#000 !important',
                        background: isDarkMode ? '#2d3a52' : '#f2f2f2',
                    },
                    '& input': {
                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                    },
                    '& .MuiAutocomplete-paper': {
                        backgroundColor: isDarkMode ? '#1F2A40' : '#fff',
                    },
                }}
                renderInput={(params) => (
                    <TextField
                        focused
                        autoComplete='off'
                        {...params}
                        onChange={(e)=>setTextSearch(e.target.value)}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                            startAdornment:(
                                <SearchIcon sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50',marginTop:-1}} size={20} />
                            ),
                            endAdornment: (
                            <Fragment>
                                {isLoading ? <CircularProgress sx={{color: isDarkMode ? '#64B5F6' : '#0364ff',marginTop:-1}} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </Fragment>
                            ),
                        }}
                        sx={{
                            '& fieldset': {
                                borderRadius: 20
                            },
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: isDarkMode ? '#64B5F6' : '#0364ff',
                                },
                            },
                            '& input': {
                                marginTop: -1,
                            },
                        }}
                    />
                )}
                renderOption={(props,option)=>{
                    let cortarTitulo = option?.tituloCard;
                    let cortarDescr = option?.descripCard?.replace(/<[^>]*>?/gm, '');
                    cortarDescr = cortarDescr?.replace(/&nbsp[;]?/ig, '');
                    if(cortarTitulo?.length > 30){
                        cortarTitulo = `${cortarTitulo?.substring(0,32)}...`
                    }
                    if(cortarDescr?.length > 80){
                        cortarDescr = `${cortarDescr?.substring(0,80)}...`
                    }
                    return (
                        <CardSearchNav
                            itemsProsp={props}
                            item={option}
                            descripcion={cortarDescr}
                            titulo={cortarTitulo}
                            key={option?.keyCard}
                            onClick={onClick}
                        />
                    )
                }}
            />
        </Box>
    );
};

InputSearchDireccionEntrega.defaultProps = {
    isClearable: false,
    value: null
};

export default InputSearchDireccionEntrega;